import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextHyp } from "./TextHyp";
import { SourcesHyp } from "./SourcesHyp";

export default function Hyp() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};
    

return(
<>      
<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Hypertension Genes' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Hypertension Genes - Variants'

        content={<TextHyp />}

        sources={<SourcesHyp />}

    />

</>
)}